import { modal } from 'react-modal-dom';

const MyBigModal = () => {
  return (
    <div className='modal-big' onClick={modal.close} arria-hidden="true">
      <img src='/picture.jpg' alt='' />
    </div>
  );
};

export default MyBigModal;
